module.exports = __webpack_public_path__ + "static/media/kofte1.bcc30e5f.png";